import { render } from "./HallOfFame.vue?vue&type=template&id=23294110&scoped=true"
import script from "./HallOfFame.vue?vue&type=script&scoped=true&lang=js"
export * from "./HallOfFame.vue?vue&type=script&scoped=true&lang=js"

import "./HallOfFame.vue?vue&type=style&index=0&id=23294110&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23294110"]])

export default __exports__